export const CORENAME = "Hair Growth Nutraceutical";
export const CARENAME = "Hair Care";
export const SKINNAME = "Clear Skin Nutraceutical";
export const BOOSTERNAME = "Hair Wellness Booster";
export const SCALPNAME = "Scalp Support";
export const SKINCATEGORY = "Skin";
export const BOOSTERCATEGORY = "Targeted Boosters";
export const HAIRGROWTHKIT = "Hair Growth Kit";

export const PRODMAP: Record<string, string> = {
  "ADV1-S01": "Hair Growth Nutraceutical for women",
  "BAL1-S01": "Women's Balance Hair Growth Nutraceutical",
  "POS1-S01": "Postpartum Hair Growth Nutraceutical",
  "RPURIFIER-N01": "Shampoo",
  "SDEFENDER-N01": "Conditioner",
  "GACTIVATOR-N01": "Hair Serum",
  "BBLOCKER-N01": "Scalp Mask",
  "HBALANCEKIT-N01": "Scalp Travel Set",
  "ADVFHK3-S01": "Fullest Hair Kit",
  "MENPRO1-S01": "Hair Growth Nutraceutical for men",
  "MENFUL1-S01": "Full Support",
};
